/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=786ac020&scoped=true&"
import script from "./transaction.vue?vue&type=script&lang=ts&"
export * from "./transaction.vue?vue&type=script&lang=ts&"
import style0 from "./transaction.vue?vue&type=style&index=0&id=786ac020&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786ac020",
  null
  
)

export default component.exports